import { Decoder, field, number, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../Resource/Decoders';
import { Resource } from '../../../../Resource/Types';

// Client types
export interface KeyMetricsPayload {
  activeProductLicensesAvailable: number;
  productLicensesPurchased: number;
  activeParticipants: number;
  pfCountWithStudentCourseReg: number;
  pfCountUnderActiveProductLicenses: number;
}

export type KeyMetricsResource = Resource<KeyMetricsPayload>;

export type KeyMetricsTitle = 'Active Participants' | 'Activated Licenses' | 'Programs In Use';

// Decoder
const keyMetricsPayloadDecoder: Decoder<KeyMetricsPayload> = succeed({})
  .assign('activeProductLicensesAvailable', field('active_product_licenses_available', number))
  .assign('productLicensesPurchased', field('product_licenses_purchased', number))
  .assign('activeParticipants', field('active_participants', number))
  .assign('pfCountWithStudentCourseReg', field('pf_count_with_student_course_reg', number))
  .assign(
    'pfCountUnderActiveProductLicenses',
    field('pf_count_under_active_product_licenses', number),
  );

export const keyMetricsResourceDecoder = resourceDecoder(keyMetricsPayloadDecoder);
